var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.isLoging ? '' : 'fixed-box'
  }, [_vm.RouterState ? _c('router-view') : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };